import { useSelector, useDispatch } from 'react-redux'
import { List } from '@mui/material'
import NavButton from './NavButton'
import { sidebarProps } from './constants'
import { useEffect, useState } from 'react'
import { addNodes } from '../../../actions/sidebar'
import { getUsersActivations, generateLessonNodes } from './utils'
import { checkActivationBySlug, hasRole } from '../../../utils/utilityFuncs'

const NavList = () => {
  const { ui, auth, initial } = useSelector(state => state) || {}
  const { enableStudentLedExoLabs } = initial || {}
  const { hasFeaturedLab } = ui.sidebar || {}

  const returnKeys = () => {
    const keySet = new Set()
    const isAdmin = hasRole(['superadmin', 'district-admin'], auth.user.roles)
    const hasExolabActivated = isAdmin || checkActivationBySlug('exolab', initial.activations)
    const hasVirtualExolabActivated = isAdmin || checkActivationBySlug('virtual-exolab', initial.activations)
    const canAccessDeviceManager = hasExolabActivated || hasVirtualExolabActivated

    auth.user.roles.forEach(({ type }) => {
      let roleKeys = sidebarProps[type]?.keys || []

      if (type === 'student' && !enableStudentLedExoLabs) {
        roleKeys = roleKeys.filter(key => key !== 'deviceManager')
      }
      if (!canAccessDeviceManager) {
        roleKeys = roleKeys.filter(key => key !== 'deviceManager')
      }
      if (!hasFeaturedLab) {
        roleKeys = roleKeys.filter(key => key !== 'featuredLab')
      }
      if (!hasVirtualExolabActivated) {
        roleKeys = roleKeys.filter(key => key !== 'virtualExolab')
      }

      roleKeys.forEach(key => keySet.add(key))
    })

    return Array.from(keySet)
  }

  const [nodes, setNodes] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    (async function () {
      const nodes = await generateLessonNodes(auth.user.roles, initial.activations)
      dispatch(addNodes(nodes))
      setNodes(nodes)
    })()
  }, [])

  if (!nodes) return null

  const keys = [...returnKeys(), ...getUsersActivations(auth, nodes, initial)]

  return (
    <List disablePadding>
      {keys.map((key, i) =>
        key !== 'keys' && ui.sidebar.tree[key]
          ? <NavButton key={i} {...ui.sidebar.tree[key]} />
          : null
      )}
    </List>
  )
}

export default NavList
